'use client';
import { useEffect, useRef, useState } from 'react';

import NumberFlow from '@number-flow/react';
import { useInView } from 'motion/react';
import { useMediaQuery } from 'usehooks-ts';

type Props = React.ComponentProps<typeof NumberFlow> & {
    delay?: number; // задержка в миллисекундах
};

export const NumberFlowOnLoadPage = ({ value: targetValue, delay = 0, ...props }: Props) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: '-200px', initial: false });
    const isMobile = useMediaQuery('(max-width: 768px)');

    const [value, setValue] = useState(0);
    useEffect(() => {
        if (!isInView) return;

        const timer = setTimeout(() => {
            setValue(targetValue);
        }, delay);

        return () => clearTimeout(timer);
    }, [isInView, targetValue, delay]);

    return (
        <NumberFlow
            aria-label={String(targetValue)}
            aria-live="off"
            ref={ref}
            value={isMobile ? targetValue : value}
            defaultValue={isMobile ? targetValue : 0}
            lang="ru-RU"
            isolate
            {...props}
        />
    );
};
